var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.formaPagamento === "A_VISTA" &&
    (_vm.tipoProcesso === "CERTIDAO_TITULO" ||
      (!_vm.excedente &&
        !_vm.dadosVtn.respeitaLegislacaoAmbiental &&
          !_vm.dadosVtn.temDireitoRegularizacao))
      ? _c(
          "div",
          { staticClass: "px-30" },
          [
            _vm.dadosVtn.calculosVtn.resumoVtn
              ? _c(
                  "el-table",
                  {
                    staticClass: "mt-3",
                    attrs: { data: _vm.dadosVtn.calculosVtn.resumoVtn }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "Resumo", prop: "descricao" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn.resumoVtn
                                          .length -
                                          1
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.descricao) + "  ")]
                                ),
                                scope.row.descricao === "Custas agrárias"
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.msgAgrarias,
                                          placement: "right"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-question-circle"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2309902165
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "Valor (R$)", prop: "valor" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn.resumoVtn
                                          .length -
                                          1
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDouble")(scope.row.valor)
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3026166604
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Quantidade em UPFPA",
                        prop: "quantidadeUPFPA"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn.resumoVtn
                                          .length -
                                          1
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDouble")(
                                          scope.row.quantidadeUPFPA
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2289047466
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    (_vm.formaPagamento === "A_VISTA" || _vm.formaPagamento === "PARCELADO") &&
    (_vm.dadosVtn.respeitaLegislacaoAmbiental ||
      _vm.dadosVtn.temDireitoRegularizacao) &&
    !_vm.excedente
      ? _c(
          "div",
          { staticClass: "px-30" },
          [
            _vm.dadosVtn.calculosVtn.resumoVtnComDesconto
              ? _c(
                  "el-table",
                  {
                    staticClass: "mt-3",
                    attrs: {
                      data: _vm.dadosVtn.calculosVtn.resumoVtnComDesconto
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "Resumo com desconto",
                        prop: "descricao"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn
                                          .resumoVtnComDesconto.length -
                                          1
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.descricao) + "  ")]
                                ),
                                scope.row.tipoDesconto ===
                                  "RESPEITA_LEGISLACAO_AMBIENTAL" ||
                                scope.row.tipoDesconto ===
                                  "TEM_DIREITO_REGULARIZACAO"
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.getMensagem(
                                            scope.row.tipoDesconto
                                          ),
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "icon",
                                          attrs: {
                                            icon: "info-circle",
                                            size: "1x"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3451098
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "Valor (R$)", prop: "valor" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn
                                          .resumoVtnComDesconto.length -
                                          1
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDouble")(scope.row.valor)
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3046215142
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Quantidade em UPFPA",
                        prop: "quantidadeUPFPA"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn
                                          .resumoVtnComDesconto.length -
                                          1
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDouble")(
                                          scope.row.quantidadeUPFPA
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2140224448
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm.formaPagamento === "PARCELADO" &&
    !(
      _vm.dadosVtn.respeitaLegislacaoAmbiental ||
      _vm.dadosVtn.temDireitoRegularizacao
    ) &&
    !_vm.excedente
      ? _c(
          "div",
          { staticClass: "px-30" },
          [
            _c(
              "el-table",
              { staticClass: "mt-3", attrs: { data: _vm.getResumoVtn } },
              [
                _c("el-table-column", {
                  attrs: { label: "Resumo", prop: "descricao" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: {
                                  label:
                                    scope.$index ===
                                    _vm.dadosVtn.calculosVtn.resumoVtn.length -
                                      1
                                }
                              },
                              [_vm._v(_vm._s(scope.row.descricao) + "  ")]
                            ),
                            scope.row.tipoDesconto ===
                              "RESPEITA_LEGISLACAO_AMBIENTAL" ||
                            scope.row.tipoDesconto ===
                              "TEM_DIREITO_REGULARIZACAO"
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.getMensagem(
                                        scope.row.tipoDesconto
                                      ),
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "icon",
                                      attrs: { icon: "info-circle", size: "1x" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2598525552
                  )
                }),
                _c("el-table-column", {
                  attrs: { label: "Valor (R$)", prop: "valor" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: {
                                  label:
                                    scope.$index ===
                                    _vm.dadosVtn.calculosVtn.resumoVtn.length -
                                      1
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDouble")(scope.row.valor)
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3026166604
                  )
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Quantidade em UPFPA",
                    prop: "quantidadeUPFPA"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: {
                                  label:
                                    scope.$index ===
                                    _vm.dadosVtn.calculosVtn.resumoVtn.length -
                                      1
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDouble")(
                                      scope.row.quantidadeUPFPA
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2289047466
                  )
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm.formaPagamento === "PARCELADO" && !_vm.excedente
      ? _c(
          "div",
          { staticClass: "px-30" },
          [
            _c(
              "el-table",
              {
                staticClass: "mt-3",
                attrs: { data: _vm.dadosVtn.calculosVtn.resumoVtnParcelas }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "Detalhamento das parcelas",
                    prop: "descricao"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: {
                                  label:
                                    scope.$index ===
                                    _vm.dadosVtn.calculosVtn.resumoVtnParcelas
                                      .length -
                                      1
                                }
                              },
                              [_vm._v(_vm._s(scope.row.descricao))]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    156221305
                  )
                }),
                _c("el-table-column", {
                  attrs: { label: "Data vencimento", prop: "dataVencimento" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: {
                                  label:
                                    scope.$index ===
                                    _vm.dadosVtn.calculosVtn.resumoVtnParcelas
                                      .length -
                                      1
                                }
                              },
                              [_vm._v(_vm._s(scope.row.dataVencimento || "-"))]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    479439593
                  )
                }),
                _c("el-table-column", {
                  attrs: { label: "Valor (R$)", prop: "valor" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: {
                                  label:
                                    scope.$index ===
                                    _vm.dadosVtn.calculosVtn.resumoVtnParcelas
                                      .length -
                                      1
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDouble")(scope.row.valor)
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1424257559
                  )
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Quantidade em UPFPA",
                    prop: "quantidadeUPFPA"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: {
                                  label:
                                    scope.$index ===
                                    _vm.dadosVtn.calculosVtn.resumoVtnParcelas
                                      .length -
                                      1
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDouble")(
                                      scope.row.quantidadeUPFPA
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    122413617
                  )
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    (_vm.formaPagamento === "A_VISTA" || _vm.formaPagamento === "PARCELADO") &&
    _vm.excedente &&
    _vm.tipoProcesso !== "CERTIDAO_TITULO"
      ? _c(
          "div",
          { staticClass: "px-30" },
          [
            _vm.dadosVtn.calculosVtn.resumoParcelaExcedente
              ? _c(
                  "el-table",
                  {
                    staticClass: "mt-3",
                    attrs: {
                      data: _vm.dadosVtn.calculosVtn.resumoParcelaExcedente
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "Resumo", prop: "descricao" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn
                                          .resumoParcelaExcedente.length -
                                          1
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.descricao) + "  ")]
                                ),
                                scope.row.descricao === "Custas agrárias"
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.msgAgrarias,
                                          placement: "right"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-question-circle"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2075959252
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "Valor (R$)", prop: "valor" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn
                                          .resumoParcelaExcedente.length -
                                          1
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDouble")(scope.row.valor)
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4059599021
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Quantidade em UPFPA",
                        prop: "quantidadeUPFPA"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      label:
                                        scope.$index ===
                                        _vm.dadosVtn.calculosVtn
                                          .resumoParcelaExcedente.length -
                                          1
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDouble")(
                                          scope.row.quantidadeUPFPA
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1508267339
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fbf964d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbf964d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppResumoParcelasVtn.vue
// module id = null
// module chunks = 